module.exports = __webpack_public_path__ + "media/images/front/logo_dba-e9afa433deb7967b572b5560c157cbc0.png";